import SamaritanFetch from './httpClient';

export const fetchRemoteCopy = (copyType: string) =>
    SamaritanFetch.v3(`/remote_copies/${copyType}`, {
        headers: {
            Accept: 'application/json'
        }
    });
